<template>
  <div style="padding: .05rem 0 0 .05rem;height:.15rem;">
    <div class="flex">
      <div class="vTitle flex">
        <img class="titleimg" src="~images/components/vtitleh.png" alt="" />
        <slot></slot>
      </div>
      <img class="titleI" src="~images/components/vtitle.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style lang="stylus" scoped>
.vTitle
  background-image -webkit-linear-gradient(top, #fff, #A1C7E8, #7BBEF6)
  -webkit-background-clip text
  -webkit-text-fill-color transparent
  font-size 0.09rem
  line-height 0.15rem
  font-weight 600
  padding-left .1rem
.flex
  align-items center
.titleI
  height 50%
  margin-left .1rem
// @media (max-width 1280px)
//   .titleI
//     width 1.3rem
</style>
